import * as Orders from './orders';
import * as RequestInstallationDevice from './RequestsInstallationDevice';
import * as Stock from './stock';

const Actions = {
  ...Orders,
  ...Stock,
  ...RequestInstallationDevice,
};

export default Actions;
